'use client'

import React, { useMemo } from 'react'
import { Col, Row, Spin } from 'antd'

import useSWR from 'swr'

import ResourceCard from './ResourceCard'
import { resourceConfigs } from './resourceConfigs'
import { getStats } from '@/service/stats'
import { useConfigContext } from '@/context/config-context'

const ResourceOverview: React.FC = () => {
  const { data: stats, isLoading: statsLoading } = useSWR<any>(
    {
      url: '/api/stats',
      params: {
        scope: 'project',
        group_by: 'status',
      },
    },
    getStats,
    {
      fallbackData: {},
      revalidateOnMount: true,
    },
  )

  const config = useConfigContext()

  const filteredResourceConfigs = useMemo(() => {
    return resourceConfigs.filter(cfg => {
      if (!config.mlops.ecs.enabled && cfg.listPath.startsWith('/ecs')) {
        return false
      }
      if (!config.mlops.train.enabled && cfg.listPath.startsWith('/train')) {
        return false
      }
      if (!config.mlops.deploy.enabled && cfg.listPath.startsWith('/deploy')) {
        return false
      }
      return true
    })
  }, [config])
  // Group resource configs for different row layouts
  const firstRowConfigs = filteredResourceConfigs.slice(0, 3)
  const secondRowConfigs = filteredResourceConfigs.slice(3, 6)
  const thirdRowConfigs = filteredResourceConfigs.slice(6, 8)

  return (
    <Spin spinning={statsLoading}>
      <div className='flex flex-col gap-4'>
        <Row gutter={8}>
          {firstRowConfigs.map((config, index) => (
            <Col key={index} span={config.span || 8}>
              <ResourceCard
                Icon={config.icon}
                titleKey={config.titleKey}
                createPath={config.createPath}
                listPath={config.listPath}
                createLabelKey={config.createLabelKey}
                statsKey={config.statsKey}
                statsConfig={config.statsConfig}
                stats={stats}
              />
            </Col>
          ))}
        </Row>
        <Row gutter={8}>
          {secondRowConfigs.map((config, index) => (
            <Col key={index} span={config.span || 8}>
              <ResourceCard
                Icon={config.icon}
                titleKey={config.titleKey}
                createPath={config.createPath}
                listPath={config.listPath}
                createLabelKey={config.createLabelKey}
                statsKey={config.statsKey}
                statsConfig={config.statsConfig}
                stats={stats}
              />
            </Col>
          ))}
        </Row>
        <Row gutter={8}>
          {thirdRowConfigs.map((config, index) => (
            <Col key={index} span={config.span || 8}>
              <ResourceCard
                Icon={config.icon}
                titleKey={config.titleKey}
                createPath={config.createPath}
                listPath={config.listPath}
                createLabelKey={config.createLabelKey}
                statsKey={config.statsKey}
                statsConfig={config.statsConfig}
                stats={stats}
              />
            </Col>
          ))}
        </Row>
      </div>
    </Spin>
  )
}

export default ResourceOverview
